/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import ProfileModel from '../../models/ProfileModel';
import BirthSexModel from '../../models/BirthSexModel';

class LocalizedBirthSex extends React.Component {

  UNSAFE_componentWillMount() {
    if (this.props.getInitialData) {
      this.props.getInitialData();
    }
  }

  render() {
    const profileModel = this.props.profile;
    const birthSex = BirthSexModel.createFromId(this.props.birthSexCollection, profileModel.data.birth_sex_id);

    if (!birthSex.messageKey()) {
      return <span />;
    }

    const birthSexName = this.props.intl.formatMessage({
      id: birthSex.messageKey(),
    });

    if (this.props.children) {
      return this.props.children(birthSexName);
    } else {
      return (
        <span>
          {birthSexName}
        </span>
      );
    }
  }
}
LocalizedBirthSex.propTypes = {
  children: PropTypes.func,
  intl: PropTypes.object.isRequired,
  birthSexCollection: PropTypes.array.isRequired,
  getInitialData: PropTypes.func.isRequired,
  profile: PropTypes.instanceOf(ProfileModel).isRequired,
};

export default injectIntl(LocalizedBirthSex);
